// Pronunciation-quality ratings. Saved locally in IndexedDB (never lost) AND
// POSTed to the server (best-effort) so we can see which words/sounds need better
// recordings. Server endpoint: <UPLOAD_URL base>/rate (see scripts/upload-server.mjs).

import { RATE_URL } from './config.js'

const DB_NAME = 'phonic-ratings'
const STORE = 'ratings'
const VERSION = 1

let dbP = null
function db() {
  if (dbP) return dbP
  dbP = new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, VERSION)
    req.onupgradeneeded = () => { const d = req.result; if (!d.objectStoreNames.contains(STORE)) d.createObjectStore(STORE, { keyPath: 'id' }) }
    req.onsuccess = () => resolve(req.result)
    req.onerror = () => reject(req.error)
  })
  return dbP
}
function store(mode) { return db().then((d) => d.transaction(STORE, mode).objectStore(STORE)) }
function reqP(r) { return new Promise((res, rej) => { r.onsuccess = () => res(r.result); r.onerror = () => rej(r.error) }) }

const rateEndpoint = () => RATE_URL || ''

// Save one rating: { word, segments:[codes], rating:1-5, source, child, ts }.
export async function saveRating(r) {
  const rec = { synced: false, ...r, id: (r && r.id) || `${(r && r.ts) || Date.now()}-${Math.random().toString(36).slice(2, 7)}` }
  try { const s = await store('readwrite'); await reqP(s.put(rec)) } catch (_) { /* ignore */ }
  const url = rateEndpoint()
  if (url) {
    try {
      const res = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(rec) })
      if (res.ok) { rec.synced = true; try { const s = await store('readwrite'); await reqP(s.put(rec)) } catch (_) {} }
    } catch (_) { /* stays local; sync later */ }
  }
  return rec
}

// Aggregate this device's ratings per word → { <lowercaseWord>: { sum, count, avg } }.
export async function ratingsByWord() {
  try {
    const all = await reqP((await store('readonly')).getAll())
    const m = {}
    for (const r of all) {
      if (!r || !r.word || typeof r.rating !== 'number') continue
      const k = String(r.word).toLowerCase()
      const e = m[k] || (m[k] = { sum: 0, count: 0 })
      e.sum += r.rating; e.count += 1
    }
    for (const k in m) m[k].avg = m[k].sum / m[k].count
    return m
  } catch (_) { return {} }
}

// Push any not-yet-synced local ratings to the server (call when it's reachable).
export async function syncRatings() {
  const url = rateEndpoint()
  if (!url) return { synced: 0, pending: 0 }
  let synced = 0, pending = 0
  try {
    const all = await reqP((await store('readonly')).getAll())
    for (const rec of all) {
      if (rec.synced) continue
      try {
        const res = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(rec) })
        if (res.ok) { rec.synced = true; await reqP((await store('readwrite')).put(rec)); synced++ } else pending++
      } catch (_) { pending++ }
    }
  } catch (_) { /* ignore */ }
  return { synced, pending }
}
